<div class="custom-timeline">
  <div class="ct-container">
    <ng-container *ngFor="let item of timelineItems">
      <div
        *ngIf="item.type === 'line'"
        class="ct-segment"
        [ngStyle]="{
          backgroundColor: item.color,
          width: item.widthPercent + '%'
        }"
      ></div>
      <div
        *ngIf="item.type === 'dot'"
        [ngClass]="item.color === '#ebebebff' ? 'date-dot' : 'status-dot'"
        [ngStyle]="{ backgroundColor: item.color }"
      >
        <div class="dot-container">
          <div class="title">{{ item.days }}</div>
          <div
            class="label"
            [ngClass]="item.color === '#ebebebff' ? 'date' : 'days'"
          >
            {{ item.color === '#ebebebff' ? date : item.days + ' ' + days}}
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
